import { TRANSLATION_KEYS as FINANCIAL_TRANSLATION_KEYS } from 'partner360/features/financialPlanQuality/configs/translations'
import { TRANSLATION_KEYS as INITIATIVES_TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import { PlanReviewSection, TPlanReviewQualitySection } from '../model/types'

import { PLAN_REVIEW_TRANSLATIONS } from './translations'

export interface IPlanReviewMenuItem {
  key: TPlanReviewQualitySection
  title: string
}

export interface IPlanReviewMenuGroup {
  key: 'financial' | 'initiatives'
  title: string
  items: readonly IPlanReviewMenuItem[]
}

export const PLAN_REVIEW_GROUPS: readonly IPlanReviewMenuGroup[] = [
  {
    key: 'financial',
    title: FINANCIAL_TRANSLATION_KEYS.tab.title,
    items: [
      {
        key: PlanReviewSection.FinancialGrowth,
        title: FINANCIAL_TRANSLATION_KEYS.quality.financialGrowth.title,
      },
      {
        key: PlanReviewSection.SobGrowth,
        title: FINANCIAL_TRANSLATION_KEYS.quality.sobGrowth.title,
      },
    ],
  },
  {
    key: 'initiatives',
    title: INITIATIVES_TRANSLATION_KEYS.quality.title,
    items: [
      {
        key: PlanReviewSection.FinancialPlanCoverage,
        title: INITIATIVES_TRANSLATION_KEYS.quality.financialPlanCoverage.title,
      },
      {
        key: PlanReviewSection.DescriptionQuality,
        title: INITIATIVES_TRANSLATION_KEYS.quality.descriptionQuality.title,
      },
      {
        key: PlanReviewSection.StrategicGrowthAreas,
        title: INITIATIVES_TRANSLATION_KEYS.quality.strategicAlignment.title,
      },
    ],
  },
]

export const getPlanReviewGroup = (section: PlanReviewSection) =>
  PLAN_REVIEW_GROUPS.find((group) => group.items.some((item) => item.key === section))

export const PLANNING_MEASURE_MENU_ITEM: IPlanReviewMenuItem = {
  key: PlanReviewSection.PlanningMeasure,
  title: PLAN_REVIEW_TRANSLATIONS.planningMeasure.title.key,
}

export const getPlanReviewMenuItems = (
  includePlanningMeasure = false
): readonly IPlanReviewMenuItem[] => [
  ...PLAN_REVIEW_GROUPS[0].items,
  ...(includePlanningMeasure ? [PLANNING_MEASURE_MENU_ITEM] : []),
  ...PLAN_REVIEW_GROUPS[1].items,
]

export const getPlanReviewItem = (section: PlanReviewSection) =>
  getPlanReviewMenuItems(true).find((item) => item.key === section)
